import React, { Component } from 'react';

export default (Modal) =>
  class ModalWrapper extends Component {
    constructor(props) {
      super(props);

      this.state = {
        opened: false,
      };

      this.open = this.open.bind(this);
      this.close = this.close.bind(this);
      this.isOpened = this.close.bind(this);
    }

    open = () => {
      this.setState({ opened: true });
    };

    close = () => {
      this.setState({ opened: false });
    };

    isOpened = () => this.state.opened;

    render() {
      const { opened } = this.state;
      return (
        <Modal
          {...this.props}
          opened={opened}
          closeHandler={() => {
            if (this.props.closeHandler) {
              this.props.closeHandler();
            }
            this.close();
          }}
        />
      );
    }
  };
